export enum AppPublishType {
  LOB_App = "LOB_App", // App published to a tenant
  Store_App = "Store_App", // App Published to teams store Ring 4
  CDN_App = "CDN_App", // App published to CDN can be any of the rings 0 to 4
  TDP_App = "TDP_App", // Any app inside TDP
}

export interface IPublishingStatusBase {
  wasAppFound: boolean
}

export interface IAppPublishingCdnStatus extends IPublishingStatusBase {
  appVersion: string,
  ringFolder: string
}
